"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { WP_Term_Query } from "@/integrations/wordpress/wp_term_query";
import { EcommerceTermsProvider, useEcommerceTerms } from "@/integrations/wordpress/WordPressEcommerceTermsProvider";
const wp_term_query_params = {
  taxonomy: "product_cat",
  per_page: 4,
  orderby: "count",
  order: "desc"
};
const wp_term_query = new WP_Term_Query(wp_term_query_params);
function ProductCategoriesConsumer() {
  const {
    terms,
    loading,
    error
  } = useEcommerceTerms();
  if (loading) {
    return <div className="mx-auto max-w-7xl px-4">
        <div className="grid grid-cols-2 gap-4 md:grid-cols-4 md:gap-6">
          {[...Array(4)].map((_, i) => <div key={i} data-index={i} className="h-40 animate-pulse rounded-md bg-muted/50 md:h-48" />)}
        </div>
      </div>;
  }
  if (error || !terms || terms.length === 0) {
    return null;
  }
  const serviceContent = [{
    title: "Roof Repair",
    description: "Expert roofing repair and replacement to keep your home safe and dry through every season.",
    link: "/RoofRepairPage",
    img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/roof_repair_service.png"
  }, {
    title: "Roof Replacement",
    description: "Expert roofing repair and replacement using premium materials designed for long-lasting protection.",
    link: "/RoofReplacementPage",
    img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/roof_replacement_service.png"
  }, {
    title: "Siding Installation",
    description: "Expert roofing repair and replacement and siding upgrades that boost your home's curb appeal and efficiency.",
    link: "/SidingReplacementPage",
    img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/siding_installation_service.png"
  }, {
    title: "Storm Damage Repair",
    description: "Expert roofing repair and replacement with rapid response to restore your peace of mind after the storm.",
    link: "/StormDamageRepairPage",
    img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/storm_damage_restoration.png"
  }];
  return <div className="mx-auto max-w-7xl px-4">
      <div className="grid grid-cols-2 gap-4 md:grid-cols-4 md:gap-6">
        {serviceContent.map((service, i) => {
        return <div key={i} data-index={i} className="group flex flex-col items-center justify-center rounded-md p-6 text-center transition-all duration-300 hover:-translate-y-1 hover:shadow-md md:p-8 bg-card border border-border/20">
              <Link to={service.link} className="mb-4 flex h-16 w-16 items-center justify-center overflow-hidden rounded-md bg-muted shadow-sm md:h-20 md:w-20">
                <img src={service.img} alt={service.title} className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-110" loading="lazy" />
              </Link>
              <Link to={service.link}>
                <h3 className="font-default text-base font-bold md:text-xl text-primary mb-2 hover:text-secondary transition-colors">
                  {service.title}
                </h3>
              </Link>
              <p className="text-sm text-muted-foreground mb-4 line-clamp-3">
                {service.description}
              </p>
              <Link to="/ServiceAreasPage" className="text-xs font-medium text-primary/70 hover:text-secondary mb-3 transition-colors">
                Serving your area
              </Link>
              <Link to={service.link} className="text-xs font-bold uppercase tracking-wider text-secondary hover:underline">
                Learn More
              </Link>
            </div>;
      })}
      </div>
    </div>;
}
export default function ServicesOverview() {
  return <section data-section-id="256874" id="services-overview" className="bg-background text-foreground py-12 md:py-20">
      <EcommerceTermsProvider wp_term_query={wp_term_query}>
        <ProductCategoriesConsumer />
      </EcommerceTermsProvider>
    </section>;
}